import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
          Inizia a Utilizzare ItaoBuy Spreadsheet Oggi
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-xl mx-auto">
          Unisciti a migliaia di utenti che hanno già trasformato il loro modo di gestire prodotti e ordini con strumenti professionali.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6">
          <Link
            to="/articoli/guida-completa-itaobuy-spreadsheet"
            className="flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-primary-600"
          >
            Scopri tutti gli strumenti
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-accent-600"
          >
            Visita itaobuy sheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-14">
        <div className="flex items-end justify-center gap-4 md:gap-6 flex-wrap">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20beige%20leather%20sneakers%20with%20minimalist%20design%20isolated%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20fashion%20footwear%20photography%2C%20simple%20refined%20composition%2C%20subtle%20shadows&width=180&height=240&seq=cta-shoes-v2&orientation=portrait"
            alt="Scarpe" title="Scarpe - ItaoBuy Spreadsheet"
            className="w-16 md:w-24 h-auto object-cover rounded-xl opacity-90 hover:opacity-100 transition-opacity"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20cream%20colored%20baseball%20cap%20with%20subtle%20texture%20isolated%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20fashion%20headwear%20photography%2C%20simple%20refined%20composition%2C%20subtle%20shadows&width=180&height=240&seq=cta-hat-v2&orientation=portrait"
            alt="Cappelli" title="Cappelli - ItaoBuy Spreadsheet"
            className="w-16 md:w-24 h-auto object-cover rounded-xl opacity-90 hover:opacity-100 transition-opacity"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20tan%20leather%20belt%20with%20subtle%20gold%20buckle%20coiled%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20fashion%20accessory%20photography%2C%20simple%20refined%20composition%2C%20subtle%20shadows&width=180&height=240&seq=cta-belt-v2&orientation=portrait"
            alt="Cinture" title="Cinture - ItaoBuy Spreadsheet"
            className="w-16 md:w-24 h-auto object-cover rounded-xl opacity-90 hover:opacity-100 transition-opacity"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20structured%20beige%20tote%20handbag%20with%20clean%20lines%20isolated%20on%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20luxury%20handbag%20photography%2C%20simple%20refined%20composition%2C%20subtle%20shadows&width=180&height=240&seq=cta-bag-v2&orientation=portrait"
            alt="Borse" title="Borse - ItaoBuy Spreadsheet"
            className="w-16 md:w-24 h-auto object-cover rounded-xl opacity-90 hover:opacity-100 transition-opacity"
          />
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20minimalist%20design%20isolated%20on%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20modern%20luxury%20fragrance%20photography%2C%20simple%20refined%20composition%2C%20subtle%20glass%20reflections&width=180&height=240&seq=cta-perfume-v2&orientation=portrait"
            alt="Profumi" title="Profumi - ItaoBuy Spreadsheet"
            className="w-16 md:w-24 h-auto object-cover rounded-xl opacity-90 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </section>
  );
}
